module.exports = __webpack_public_path__ + "static/media/eye-closed.e86e9773.svg";